module.exports = __webpack_public_path__ + "static/20230619_151-24ad359d832943c3c5fdbaac7e8552b6.jpg";